/**
 * 事件监听
 * @param {HTMLElement} element 元素
 * @param {String} event 事件名称
 * @param {Function} handler 事件处理程序
 * @param {Boolean} capture 是否捕获
 */
export const registerEvent = (element, event, handler, capture = true) => {
  if (element.addEventListener) { // 其它
    element.addEventListener(event, handler, !!capture);
  } else if (element.attachEvent) { // IE
    element.attachEvent(`on${event}`, handler);
  }
};

/**
 * 移除事件监听
 * @param {HTMLElement} element 元素
 * @param {String} event 事件名称
 * @param {Function} handler 事件处理程序
 * @param {Boolean} capture 是否捕获
 */
export const removeEvent = (element, event, handler, capture = true) => {
  if (element.removeEventListener) {
    element.removeEventListener(event, handler, !!capture);
  } else if (element.detachEvent) {
    element.detachEvent(`on${event}`, handler);
  }
};
